import { render, staticRenderFns } from "./StartTravel.vue?vue&type=template&id=3b5199b1&scoped=true"
import script from "./StartTravel.vue?vue&type=script&lang=js"
export * from "./StartTravel.vue?vue&type=script&lang=js"
import style0 from "./StartTravel.vue?vue&type=style&index=0&id=3b5199b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5199b1",
  null
  
)

export default component.exports